import { requestStatisData } from './index'
import { GenerateQueryV2 } from '../../utils/query'

export const getCountryDialCode = (payload) => {
  const queryString = GenerateQueryV2(payload)

  return requestStatisData({
    url: '/api/country?' + queryString,
    method: 'get',
  })
}

const Country = {
  getCountryDialCode
}

export default Country
